import { benefits } from '@/mocks/benefits';

export default function BenefitsSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-500 mb-3">
            Korzyści
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            Dlaczego użytkownicy wybierają Kakobuy Spreadsheet?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {benefits.map((benefit, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-lg p-6 md:p-8 border border-background-200/70 hover:border-primary-200 transition-all"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${benefit.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-3">
                {benefit.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}